import worker from './worker/index.slice';
import whitelabel from './whitelabel/index.slice';
const indexedVariable = {
  worker,
  whitelabel,
};
export default indexedVariable;
